import { TERMINAL_STATUSES, dayIn, nextDay } from '@delivery/shared';
/**
 * 金额格式化。
 *
 * ★ 只此一份。原来订单详情和结算页各写了一份实现:一份用 BigInt 除法,
 *   一份用字符串补位。两份当时结果一致 —— 但「当时一致」不等于
 *   以后一致,而金额显示不一致的 bug 只会被用户在对账时发现。
 *
 * ★ 用字符串而不是 Number:金额是最小货币单位的整数,
 *   而它可能超过 2^53(一个大租户一年的流水就够了)。
 *   `Number(minor) / 100` 在那之后开始悄悄丢精度。
 */
export function money(minor: string | number, currency = ''): string {
  const raw = typeof minor === 'number' ? String(Math.round(minor)) : minor;
  const neg = raw.startsWith('-');
  const digits = (neg ? raw.slice(1) : raw).padStart(3, '0');
  const text = `${digits.slice(0, -2)}.${digits.slice(-2)}`;
  return `${neg ? '-' : ''}${currency ? `${currency} ` : ''}${text}`;
}

/**
 * 期望送达日期的人话写法:今天 / 明天 / `09-25`。
 *
 * ★ 不直接写日期数字:调度一眼要判断的是「这是不是今天的活」,
 *   而 `09-23` 要他自己先想一下今天几号。
 *
 * ★ 「今天」按**店里**的时区算,不按这台电脑 —— 老板在国外打开管理端时,
 *   浏览器的今天可能是店里的昨天或明天。
 */
export function expectedLabel(
  at: string,
  tz: string,
  /** 订单状态。送达 / 退回 / 取消了的单不再判断「已过」 */
  status?: string,
): { text: string; state: 'past' | 'today' | 'future' | 'done' } {
  const today = dayIn(tz);
  const day = dayIn(tz, new Date(at));
  /*
   * ★ 「已过」是给**还没做完**的单的提醒:这单该送了还没送。
   *   已经送达 / 退回 / 取消的单,期望日期早就过了是正常的 ——
   *   再挂一个红色的「已过」,列表里一半都是红的,真正误期的那几单反而淹没了。
   *   (投递失败不算做完:货还在司机手上,过了期照样要提醒。)
   */
  if (status && (TERMINAL_STATUSES as readonly string[]).includes(status)) {
    const text = day === today ? '今天' : day === nextDay(today) ? '明天' : day.slice(5);
    return { text, state: 'done' };
  }
  if (day < today) return { text: `${day.slice(5)}(已过)`, state: 'past' };
  if (day === today) return { text: '今天', state: 'today' };
  if (day === nextDay(today)) return { text: '明天', state: 'future' };
  return { text: day.slice(5), state: 'future' };
}
